import type { PropTypes } from './MenuItem.types';

import { Box, Flex, Skeleton, Text, Tooltip } from '@rango-dev/whale';
import clsx from 'clsx';
import React from 'react';

import { InfoIconButton } from '../../common/InfoIconButton';

import styles from './MenuItem.module.css';

const INFO_ICON_SIZE = 16;

export function MenuItem(props: PropTypes): React.ReactElement {
  const { title, info, prefix, suffix, selected, loading } = props;
  return (
    <Flex
      justify="between"
      p="4"
      className={clsx(
        styles.container,
        selected && styles.containerSelected,
        loading && styles.loading,
      )}>
      {selected && <Box width="4px" height="32px" className={styles.indicator} />}
      <Flex gap="2" align="center">
        {loading ? <Skeleton width="24px" height="24px" /> : prefix}
        {loading ? (
          <Skeleton width="144px" height="24px" />
        ) : (
          <Text size="3" weight="medium">
            {title}
          </Text>
        )}
      </Flex>
      <Flex gap="1" align="center">
        {loading ? (
          <>
            <Skeleton width="20px" height="20px" />
            <Skeleton width="48px" height="20px" />
          </>
        ) : (
          <>
            {info && (
              <Tooltip content={info} side="left" maxWidth="178px" className={styles.infoTooltip}>
                <InfoIconButton
                  id="leaderboard-menu-item-info-btn"
                  iconSize={INFO_ICON_SIZE}
                  aria-label={info}
                />
              </Tooltip>
            )}
            {suffix}
          </>
        )}
      </Flex>
    </Flex>
  );
}
